import { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft, Trash2, X } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { BookCover } from "../components/BookCover";

export default function ShelfView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [shelf, setShelf] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/shelves/${id}`).then((r) => setShelf(r.data)).catch(() => setError(true));
  }, [id]);

  const remove = async (bookId) => {
    await api.delete(`/shelves/${id}/books/${bookId}`);
    setShelf((s) => ({ ...s, books: s.books.filter((b) => b.id !== bookId) }));
  };

  const delShelf = async () => {
    if (!window.confirm("delete this shelf? the books stay in the library.")) return;
    await api.delete(`/shelves/${id}`);
    toast.success("shelf deleted");
    navigate("/shelf");
  };

  if (error) return <div className="max-w-5xl mx-auto px-6 py-20 font-display text-3xl">shelf not found.</div>;
  if (!shelf) return <div className="max-w-5xl mx-auto px-6 py-20 font-ui text-muted-foreground">dusting the shelf…</div>;

  return (
    <div className="max-w-6xl mx-auto px-6 md:px-10 py-14 pb-32">
      <Link to="/shelf" className="inline-flex items-center gap-2 font-ui text-xs tracking-caps text-muted-foreground hover:text-primary mb-8">
        <ArrowLeft className="w-3.5 h-3.5" /> my shelf
      </Link>
      <div className="flex items-end justify-between flex-wrap gap-4">
        <h1 className="font-display text-4xl md:text-5xl tracking-tight lowercase" data-testid="shelf-view-title">{shelf.name}</h1>
        {!shelf.system && (
          <button onClick={delShelf} data-testid="delete-shelf-btn" className="inline-flex items-center gap-2 font-ui text-xs tracking-caps px-4 py-2 rounded-full border border-border hover:text-destructive transition-colors">
            <Trash2 className="w-3.5 h-3.5" /> delete shelf
          </button>
        )}
      </div>
      <div className="rule-ornament font-ui text-xs tracking-caps my-10"><span>{shelf.books.length} volumes</span></div>
      {shelf.books.length === 0 && (
        <div className="font-reader italic text-muted-foreground text-center py-16">
          nothing here yet. <Link to="/" className="text-primary underline underline-offset-4">find something →</Link>
        </div>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-10">
        {shelf.books.map((b) => (
          <div key={b.id} className="group relative" data-testid={`shelf-book-${b.id}`}>
            <Link to={`/book/${b.id}`} className="block">
              <BookCover book={b} />
              <div className="mt-3 font-display text-base leading-tight line-clamp-2 group-hover:text-primary transition-colors">{b.title}</div>
              <div className="font-ui text-xs text-muted-foreground mt-1 line-clamp-1">{b.author}</div>
            </Link>
            <button onClick={() => remove(b.id)} data-testid={`remove-from-shelf-${b.id}`} title="remove"
              className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity bg-background/90 border border-border rounded-full p-1.5 hover:text-destructive">
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
